import React from "react";
import { gbp, pct } from "@/lib/customerApi";

export default function BotKpis({ b }) {
  const k = [
    ["Backtest net profit (36 mo)", gbp(b.net_profit), "#2ECA7F"],
    ["Average / month", gbp(b.avg_monthly), "#2ECA7F"],
    ["Avg monthly return", pct(b.avg_month_pct, 2), "#38BDF8"],
    ["Max drawdown", pct(b.max_dd_pct), "#F87171"],
    ["Worst month", pct(b.worst_month_pct, 2), "#F87171"],
    ["Best month", pct(b.best_month_pct, 2), "#2ECA7F"],
    ["Profit factor", b.profit_factor ?? "-", "#F1F5F9"],
    ["Win rate", pct(b.win_rate), "#F1F5F9"],
    ["Total trades", Number(b.total_trades || 0).toLocaleString(), "#F1F5F9"],
    ["Profitable months", `${b.profit_months ?? "-"} / ${(b.profit_months || 0) + (b.losing_months || 0)}`, "#F1F5F9"],
    ["Sharpe ratio", b.sharpe ?? "-", "#F1F5F9"],
    ["Recovery factor", b.recovery_factor ?? "-", "#F1F5F9"],
    ["Avg trade", gbp(b.expected_payoff, 2), "#F1F5F9"],
    ["Max losing streak", b.max_consec_losses || "-", "#F1F5F9"],
    ["Backtest window", `${b.backtest_from} → ${b.backtest_to}`, "#94A3B8"],
  ];
  return (
    <>
    <div data-testid="bot-kpis-label" className="mt-8 mono text-[10px] uppercase tracking-widest text-[#FBBF24]">
      Backtest results (simulated - not real or demo trading) · {b.backtest_from} → {b.backtest_to} · {gbp(b.start_balance)} start · {b.symbol}
    </div>
    <div data-testid="bot-kpis" className="mt-3 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-px bg-blue-900/30 border border-blue-900/40 rounded-xl overflow-hidden">
      {k.map(([label, v, c]) => (
        <div key={label} className="bg-[#050914] p-4">
          <div className="mono text-[9px] uppercase tracking-widest text-[#64748B]">{label}</div>
          <div className="text-lg mt-1" style={{ color: c }}>{v}</div>
        </div>
      ))}
    </div>
    </>
  );
}
